import { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, FormItem, Input, Layout, Row } from '@/components/atoms';
import { Anchor, Divider, message, Modal, Space } from 'antd';
import LandingHeader from '@/components/organisms/landing/LandingHeader';
import Footer from '@/components/organisms/common/Footer';
import MockupImg from '@images/bizcenter/img_main_mockup.png';
import ErpImg from '@images/bizcenter/img_erp.png';
import ErpmobileImg from '@images/bizcenter/img_erp_phone.png';
import YsdImg from '@images/bizcenter/img_dealing.png';
import SelectIcon from '@images/bizcenter/arrow_select.png';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import { useAppDispatch } from '@/store';
import { logout } from '@/features/account/accountSlice';
import axios from 'axios';
import { PATH_MAIN } from '@/constants/constant';
import { useHistory } from 'react-router';

const HomePage = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { user } = useSelector((state: RootState) => state.account);
  const [modal, setModal] = useState({ visible: false });

  // selectbox 화살표 변경
  const selectArrow = (
    <span>
      <img src={SelectIcon} alt="옵션보기" />
    </span>
  );

  // 스크롤시 헤더 컬러 변경
  const [headerMode, setHeaderMode] = useState({ mode: 'dark' });

  const onScroll = useCallback(() => {
    const currentPosition = window.pageYOffset;
    const topHeight = document.getElementsByClassName('landing-intro-visual')[0]?.clientHeight ?? 0;
    if (currentPosition > topHeight - 50) {
      setHeaderMode({ mode: 'light' });
    } else {
      setHeaderMode({ mode: 'dark' });
    }
  }, []);

  const register = useCallback(
    (values) => {
      axios
        .post(
          '/connect-api/webhook/21346604/6c0ec7bf24640c93a9a81701152fe164',
          JSON.stringify({
            body: '새로운 차량 등록 요청이 접수되었습니다.',
            connectInfo: [
              {
                title: values.company,
                description: [
                  values.name ? `담당자: ${values.name}` : undefined,
                  values.contact ? `연락처: ${values.contact}` : undefined,
                  values.email ? `이메일: ${values.email}` : undefined,
                  values.type ? `유형: ${values.type}` : undefined,
                  values.count ? `보유 차량 수: ${values.count}` : undefined,
                ]
                  .filterNotNull()
                  .join('\n'),
              },
            ],
          }),
          {
            baseURL: 'https://corsproxy.io/?https://wh.jandi.com', // 임시프록시 서버 세팅 https://corsproxy.io/
            headers: {
              Accept: 'application/vnd.tosslab.jandi-v2+json',
              'Content-Type': 'application/json',
            },
          },
        )
        .then((response) => {
          form.resetFields();
          message.success('등록 요청이 완료되었습니다.');
        });
    },
    [form],
  );

  useEffect(() => {
    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);

  return (
    <>
      <Layout>
        {/* 헤더 */}
        <LandingHeader user={user} logout={() => dispatch(logout())} mode={headerMode.mode === 'dark' ? 'dark' : 'light'} />
        {/* //헤더 */}
        {/* 비주얼영역 */}

        <Layout id="initial" className="landing-intro-visual">
          <Space className="visual-wrap">
            <div className="visual-text-box">
              <h2 className="visual-title">
                <em>핀카 비즈센터</em>에<br />
                오신 것을 환영합니다.
              </h2>
              <Divider className="visual-line inner" />
              <p className="visual-text">&nbsp;</p>
              {/* <p className="visual-text">내 차 등록하면 돈 법니다.</p> */}
              <Anchor affix={false}>
                <Button type="success" className="regist-link">
                  <Anchor.Link title="내 차 등록하기" href={`${PATH_MAIN}#register`} />
                </Button>
              </Anchor>
            </div>
            <img src={MockupImg} alt="핀카 비즈센터 실사용 예시 이미지" className="visual-mockup" />
          </Space>
          <Divider className="visual-line outer" />
          <p className="wave-bottom">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 270">
              <path
                fillOpacity="1"
                d="M0,192L80,208C160,224,320,256,480,245.3C640,235,800,181,960,176C1120,171,1280,213,1360,234.7L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
              />
            </svg>
          </p>
        </Layout>
        {/* //비주얼영역 */}
        {/* 핀카알림 */}
        {/* <Layout id="alarm" className="landing-container">
          <h3 className="landing-title icon icon-alarm">
            핀카 알림 <i />
          </h3>
          <Row align="middle">
            <Col xs={{ span: 24, order: 2 }} md={{ span: 24, order: 2 }} lg={{ span: 12, order: 1 }}>
              <div className="alarm-ex">
                <div className="alarm-box">
                  <p className="text">
                    12호1234 차량 정기검사일 알림<span>2020.11.12 3일 남았습니다.</span>
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }} lg={{ span: 12, order: 2 }}>
              <Space direction="vertical" className="remember-box">
                <h4 className="landing-title-small">안 까먹을 자신 있습니까?</h4>
                <ul className="label-list">
                  <li>시세알림</li>
                  <li>검사알림</li>
                  <li>정비알림</li>
                  <li>보험알림</li>
                  <li>대출알림</li>
                  <li>매매정보알림</li>
                </ul>
              </Space>
            </Col>
          </Row>
        </Layout> */}
        {/* //핀카알림 */}
        {/* 스마트 민원 */}
        {/* <Layout id="mimwon" className="landing-container">
          <h3 className="landing-title icon icon-mimwon">
            스마트 민원
            <i />
          </h3>
          <Row align="top">
            <Col xs={24} md={24} lg={10}>
              <p className="catch-text">
                더이상의 야근은 없다.
                <br />
                고지서 업무 핀카가 다 해드림<span>핀카 ERP를 사용하시면 원스탑 처리 가능합니다.</span>
              </p>
            </Col>
            <Col xs={24} md={24} lg={14}>
              <Space className="minwon-preview">
                <img src={BizImg} alt="스마트 민원 사용화면 예시 이미지" />
                <ol className="minwon-step-list">
                  <li>
                    <p>과태료 고지서 이미지 업로드</p>
                    <span />
                  </li>
                  <li>
                    <p>OCR 문자 인식 고지서 등록</p>
                    <span />
                  </li>
                  <li>
                    <p>운전자 변경 신청 (관공서/고속도로)</p>
                    <span />
                  </li>
                  <li>
                    <p>민원 내역 관리 (접수 확인)</p>
                  </li>
                </ol>
              </Space>
            </Col>
          </Row>
        </Layout> */}
        {/* //스마트 민원 */}
        {/* erp */}
        <Layout id="erp" className="landing-container center-container">
          <h3 className="landing-title">렌터카 ERP</h3>
          <p className="catch-text">
            PC / Mobile 차량관리
            <br />
            전자 계약 / 매출 관리
          </p>
          <ul className="label-list erp">
            <li className="">운전면허 자동 검증</li>
            <li className="">전자 계약서</li>
            <li className="">장기 대여 관리</li>
            <li className="">단기 대여 관리</li>
            <li className="">예약 관리</li>
            <li className="">차량 관리</li>
            <li className="">보험 대여 관리</li>
            <li className="">정산 매출 관리</li>
          </ul>
          <Space className="erp-preview">
            <img src={ErpImg} alt="핀카 erp 시스템 실사용 화면" className="pc" />
            <img src={ErpmobileImg} alt="핀카 erp 시스템 모바일 버전 실사용 화면" className="mobile" />
          </Space>
        </Layout>
        {/* //erp */}
        {/* 차량거래 */}
        <Layout id="contract" className="landing-container">
          <h3 className="landing-title icon icon-contract">
            차량 거래
            <i />
          </h3>
          <Row align="top">
            <Col xs={24} md={24} lg={8} className="vertical-block">
              <p className="catch-text">
                중고차 거래
                <br />
                양수도
              </p>
              <a href="https://transfer.pincar.co.kr" className="ant-btn ant-btn-dark button erp-link">
                <i />
                매물 보러가기
              </a>
            </Col>
            {/* <Col xs={24} md={24} lg={16}>
              <img src={YsdImg} alt="스마트 민원 사용화면 예시 이미지" className="contract-preview" />
            </Col> */}
            <Space className="erp-preview">
              <img src={YsdImg} alt="양수도 시스템 실사용 화면" className="pc2" />
              <img src={MockupImg} alt="양수도 시스템 모바일 버전 실사용 화면" className="mobile" />
            </Space>
          </Row>
        </Layout>
        {/* //차량거래 */}
        {/* 도입사례 - 임시 비활성화 */}
        {/* <Layout className="landing-container center-container"> */}
        {/*  <h3 className="landing-title"> */}
        {/*    핀카 비즈센터의 성공적인 */}
        {/*    <br /> */}
        {/*    도입사례를 만나보세요. */}
        {/*  </h3> */}
        {/*  <ul className="review-list"> */}
        {/*    <li> */}
        {/*      <p className="reviewer-img"> */}
        {/*        <img src={UserImg1} alt="아스타 장기렌트 erp 이용고객 사진" /> */}
        {/*      </p> */}
        {/*      <p className="review-text">핀카의 ERP 정말 편하고 좋습니다.</p> */}
        {/*      <p className="reviewer-info"> */}
        {/*        <span>아스타</span> */}
        {/*        <span>장기렌트 ERP</span> */}
        {/*      </p> */}
        {/*    </li> */}
        {/*    <li> */}
        {/*      <p className="reviewer-img"> */}
        {/*        <img src={UserImg2} alt="레드캡 투어 스마트 민원 이용고객 사진" /> */}
        {/*      </p> */}
        {/*      <p className="review-text">민원업무가 간편하고 쉬워졌어요.</p> */}
        {/*      <p className="reviewer-info"> */}
        {/*        <span>레드캡 투어</span> */}
        {/*        <span>스마트 민원</span> */}
        {/*      </p> */}
        {/*    </li> */}
        {/*    <li> */}
        {/*      <p className="reviewer-img"> */}
        {/*        <img src={UserImg3} alt="바로바로 렌트카 단기렌트 ERP 이용고객 사진" /> */}
        {/*      </p> */}
        {/*      <p className="review-text">핀카만 생각하면 눈물이 난다. 고마워요!</p> */}
        {/*      <p className="reviewer-info"> */}
        {/*        <span>바로바로 렌트카</span> */}
        {/*        <span>단기렌트 ERP</span> */}
        {/*      </p> */}
        {/*    </li> */}
        {/*  </ul> */}
        {/* </Layout> */}
        {/* //도입사례 */}
        {/* 사업자 등록 */}
        <Layout id="register" className="bg-container">
          <Layout className="landing-container">
            <div className="regist-document">
              <h3 className="landing-title">
                모빌리티 비즈니스
                <br />
                핀카가 함께합니다.
              </h3>
              <p className="text">핀카 비즈센터와 성공을 시작하세요.</p>
              <Form className="regist-form" form={form} onFinish={register}>
                <FormItem name="company" rules={[{ required: true, message: '회사 이름을 입력해주세요' }]}>
                  <Input placeholder="회사명" />
                </FormItem>
                <FormItem
                  name="contact"
                  rules={[
                    { required: true, message: '연락처를 입력해주세요' },
                    { pattern: /^01(?:0|1|[6-9])[.-]?(\d{3}|\d{4})[.-]?(\d{4})$/, message: '잘못된 형식입니다.' },
                  ]}
                >
                  <Input placeholder="연락처" />
                </FormItem>
                <FormItem name="email" rules={[{ type: 'email', message: '이메일 형식에 맞게 입력해주세요' }]}>
                  <Input placeholder="회사 이메일" />
                </FormItem>
                <FormItem name="type">
                  <Input placeholder="사업자 유형" />
                </FormItem>
                <FormItem name="count">
                  <Input placeholder="보유 차량 수" />
                </FormItem>
                <FormItem name="name">
                  <Input placeholder="이름" />
                </FormItem>
                <Button type="dark" className="btn-bizstart" htmlType="submit">
                  내 차 등록하기
                </Button>
              </Form>
            </div>
          </Layout>
        </Layout>
        {/* //사업자 등록 */}
        {/* 푸터 */}
        <Footer />
        {/* //푸터 */}
      </Layout>
      <Modal visible={modal.visible} title="신주발행공고" onCancel={() => setModal({ visible: false })} footer={null}>
        <div className="my-10">
          <p className="text-left">
            2023년 12월 15일 개최한 당사 이사회에서 유상증자에 따른 신주발행에 관하여 다음과 같이 결의하였기에 이를 공고합니다.
          </p>
        </div>
        <div className="my-10">
          <p className="text-center">- 다 음 -</p>
          <br />
          <p className="text-left">1. 신주의 종류와 수: 기명식 보통주식 650,000주</p>
          <p className="text-left">2. 신주의 액면가액: 1주당 500원</p>
          <p className="text-left">3. 신주의 발행가액: 1주당 2,000원</p>
          <p className="text-left">4. 신주의 발행방법: 제3자 배정을 통한 신주 발행</p>
          <p className="text-left">5. 신주의 배정 및 인수방법 : 정관 제 10조 (2)항 에 의거 제3자에게 배정함</p>
          <p className="text-left">6. 주금 납입기일 : 2023년 12월 30일</p>
          <br />
          <br />
          <br />
          <p className="text-center">서기 2023년12월15일</p>
          {/* <p className="text-left font-bold">임시주주총회 안건 및 일정을 아래와 같이 변경하여 통지하오니 일정에 착오 없으시기 바랍니다.</p>
          <p className="text-center font-bold">- 아 래 -</p>
          <div className="mx-8 my-20">
            <p className="text-left">(1) 일시 : 2023년 1월 27일 (금) 오전 10시 ☜ 1월20일자에서 일주일 연기됨</p>
            <p className="text-left">(2) 장소 : 경기도 용인시 처인구 역북동203-4 핀카존 2F 사무실 대회의실</p>
            <p className="text-left">(3) 회의목적변경 : 창업자(대표이사)증자가 아닌 주주 균등 증자로 변경</p>
            <p className="text-left"> [부 의 안 건] 제1호 의 안 : 자본잠식 해결을 위한 감자 및 주주 균등 증자</p>
          </div> */}
        </div>
        {/* <p className="text-center font-bold">서기 2023년 01월 13일</p> */}
        <div className="my-10">
          <p className="text-center">통지인: 주식회사 핀카</p>
          <p className="text-center">경기도 용인시 처인구 성산로 121번길 24, A동(역북동)</p>
          <p className="text-center">대표이사 안 남 훈 (직인생략)</p>
        </div>
      </Modal>
      <style>{`
        #home-modal-table {
        width: 100%;
        border: 1px solid #444444;
        text-align:center;
      }
        #home-modal-table th, #home-modal-table td {
        border: 1px solid #444444;
        text-align:center;
      }
      `}</style>
    </>
  );
};

export default HomePage;
